module.exports = __webpack_public_path__ + "img/free-days.93d707df.svg";